import { IOrderDetails } from './types';

export const getOrderCountryCode = (order: IOrderDetails): string => {
  return (
    order.shipping_address?.country_code ||
    order.segments?.[0]?.store_location?.country_code ||
    order.billing_address?.country_code ||
    'US'
  );
};

export const formatAmount = (amount: number, orderShippingCountryCode: string, shouldShowDecimals = true) => {
  // Show 2 decimals if the number has decimal places, otherwise show none (unless shouldShowDecimals is true)
  const locale = `en-${orderShippingCountryCode}`;
  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: shouldShowDecimals ? 2 : amount % 1 !== 0 ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(amount);
};
